import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3119a102"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "iframe-wrapper" }
const _hoisted_2 = {
  key: 1,
  class: "iframe-mask"
}
const _hoisted_3 = { class: "iframe-mask__content" }

import WebOfficeSDK from '@teams/common/sdk/web-office-sdk-v2.0/web-office-sdk-v2.0.0.es.js'
import { ref, onMounted, watch, onUnmounted, computed, toRefs } from 'vue'
import { useRoute } from 'vue-router'
import { commonOptions, commandBars, getOtlOptions } from './config'
import useMitt from '@/hooks/useMitt'
import { events } from '@/constants'
import { useNavigatorStore, NavViewMode } from '@teams/common/store/navigator'
import ContentToolbar, { useContentToolbar } from './contentToolbar'

import Loading from '@teams/common/components/loading'
import { IconMapping } from '@teams/common/hooks/useFileList/fileConfig'
import { createPromiseRef } from '@teams/common/utils/ref'
import { useAcl } from 'vue-simple-acl'
import aclRules from '@teams/common/acl/aclRules'


export default /*#__PURE__*/_defineComponent({
  __name: 'WOIframe',
  props: {
  url: {
    type: String,
    default: ''
  },
  ext: {
    type: String,
    default: ''
  },
  navId: Number
},
  emits: ["fileNameChange"],
  setup(__props, { emit: emits }: { emit: ({
  (e: 'fileNameChange', name: string)
}), expose: any, slots: any, attrs: any }) {

const props = __props

const route = useRoute()
const acl = useAcl()
const canEdit = computed(() => acl.can(aclRules.doc_view_edit_command))
const emitter = useMitt()
const iframeContent = ref(null)


const navigatorStore = useNavigatorStore()
const viewMode = computed(() => {
  return navigatorStore.viewModeMap[props.navId + ''] || NavViewMode.Read
})
const isReadOnlyMode = computed(() => {
  return viewMode.value !== NavViewMode.Write
})

const isOtl = computed(() => {
  return [...IconMapping.otl, ...IconMapping.otlLink].includes(props.ext)
})
const isShowCatlog = ref(false)
const setViewMode = mode => {
  navigatorStore.setNavViewMode(props.navId, mode)
}
const iframeLoaded = ref(false)
// 是否显示切换编辑
const showToggleView = computed(() => {
  const currentNavId = route?.query?.nid
  return iframeLoaded.value && currentNavId === `${props.navId}`
})
// 悬浮球拖动判断
const isDragBall = ref(false)
emitter.on(events.canMove, msg => {
  isDragBall.value = msg as boolean
})

const iframe = ref<HTMLIFrameElement | null>(null)
let instance: Record<string, unknown>
async function destroyApplication() {
  iframeLoaded.value = false
  resetInitPromise.value()
  if (instance) {
    await instance.ApiEvent?.RemoveApiEventListener(
      'fileNameChange',
      actions.common.fileNameChange
    )
    await instance.ApiEvent?.RemoveApiEventListener(
      'error',
      actions.common.onError
    )
    instance.destroy()
  }
}
async function initApplication() {
  instance = new WebOfficeSDK({
    url: props.url,
    mount: iframeContent.value,
    viewMode: 'Embed',
    isFallbackIframe: true,
    commandBars,
    commonOptions,
    otlOptions: getOtlOptions({ isReadonly: isReadOnlyMode.value })
  })
  if (!instance) {
    return
  }
  iframe.value = await instance.iframe
  iframe.value.onload = async () => {
    await hasInitPromise.value
    iframeLoaded.value = true
  }
  await instance.advancedApiReady()
  await actions.common.init()
  await hasInitPromise.value
  iframeLoaded.value = true
}

const {
  resolveFn: hasInitResolve,
  promise: hasInitPromise,
  resetPromise: resetInitPromise
} = toRefs(createPromiseRef<boolean>())

const actions = {
  common: {
    async getApp() {
      await instance.advancedApiReady()
      const app = await instance.Application
      return app
    },
    onError(e) {
      console.log('error', e)
    },
    fileNameChange: e => {
      emits('fileNameChange', e.fileName)
    },
    async init() {
      await actions.common.getApp()
      await actions.common.hideCommandBars(['FloatQuickHelp'])
      await instance.ApiEvent?.AddApiEventListener(
        'fileNameChange',
        actions.common.fileNameChange
      )
      await instance.ApiEvent?.AddApiEventListener(
        'error',
        actions.common.onError
      )
      if (isOtl.value) {
        // 产品：阅读模式和编辑模式的FP，先改为都显示文档标题（不隐藏）。下期再做优化
        // await actions.common.hideTitle()
        await actions.otl.init()
      }
      hasInitResolve.value?.(true)
    },
    async hideTitle() {
      const app = await actions.common.getApp()
      await (app as any)?.ActiveOutline?.Editor?.View?.SetTitleVisible?.({
        Visible: false
      })
    },
    async hideCommandBars(list: string[]) {
      const app = await actions.common.getApp()
      list.forEach(async cmbId => {
        const commandBar = await app.CommandBars(cmbId)
        commandBar && (commandBar.Visible = false)
      })
    }
  },
  otl: {
    async init() {
      if (!isReadOnlyMode.value) {
        return
      }
      const app = await actions.common.getApp()
      //  获取目录展开状态
      const Sidebar = await app.ActiveOutline.Sidebar
      isShowCatlog.value = await Sidebar.GetSidebarVisible()
      // 设置宽屏模式
      await actions.otl.setFullWidth(true)
    },
    async toggleSidebar() {
      const app = await actions.common.getApp()
      const Sidebar = await app.ActiveOutline.Sidebar
      const val = !isShowCatlog.value
      // 切换目录侧边栏
      await Sidebar.ToggleShow({ Visible: val })
      isShowCatlog.value = val
    },
    async setFullWidth(flag = true) {
      const app = await actions.common.getApp()
      const editor = await app.ActiveOutline.Editor
      // 打开宽屏模式
      await editor.SetPageMode({ Mode: 'FullWidth', Status: flag })
    }
  }
}
const iframeMessage = async e => {
  try {
    if (!iframe.value || iframe.value.contentWindow !== e.source) {
      return
    }
    const data = JSON.parse(e.data)
    // 接收到以下事件时隐藏loading
    if (
      ['web_remove_loading', 'web_loaded', 'ready'].includes(data.eventName) &&
      !iframeLoaded.value
    ) {
      await hasInitPromise.value
      iframeLoaded.value = true
    }
    if (
      ['web_cloud_loaded', 'web_permission'].includes(data.eventName) &&
      !iframeLoaded.value
    ) {
      iframeLoaded.value = true
    }
  } catch (e) {}
}
const message = {
  bind() {
    window.addEventListener('message', iframeMessage)
  },
  unbind() {
    window.removeEventListener('message', iframeMessage)
  }
}

const contentToolbar = useContentToolbar(
  {
    ext: computed(() => props.ext),
    viewMode,
    canEdit
  },
  {
    onOptionClick: async (key, option, toggleBtn) => {
      if (key === 'directory' && props.ext === 'otl') {
        await actions.otl.toggleSidebar()
        return false
      }
      if (key === 'edit') {
        setViewMode(NavViewMode.Write)
        toggleBtn()
        return false
      }
    },
    onEditBtnClick: () => {
      setViewMode(NavViewMode.Read)
    }
  }
)

watch([() => isShowCatlog.value, () => viewMode.value], () => {
  // 同步 isShowCatlog 与 contentToolbar directory active 的值
  contentToolbar.evtBus.emit('setListItemActive', {
    key: 'directory',
    val: isShowCatlog.value
  })
  // 同步 viewMode 与 contentToolbar edit active 的值
  contentToolbar.evtBus.emit('setListItemActive', {
    key: 'edit',
    val: viewMode.value === NavViewMode.Write
  })
})

watch(
  () => {
    return props.url
  },
  async () => {
    if (!isReadOnlyMode.value || showToggleView) {
      await destroyApplication()
    }
    initApplication()
  }
)

onMounted(() => {
  initApplication()
  message.bind()
})
onUnmounted(() => {
  destroyApplication()
  message.unbind()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "wo-content-wrapper",
      ref_key: "iframeContent",
      ref: iframeContent,
      style: _normalizeStyle(isDragBall.value ? 'pointer-events: none' : '')
    }, null, 4),
    (_unref(showToggleView))
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 0,
          to: ".view-home-body"
        }, [
          _createVNode(_unref(ContentToolbar), _normalizeProps(_guardReactiveProps(_unref(contentToolbar).props)), null, 16)
        ]))
      : _createCommentVNode("", true),
    (!iframeLoaded.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(Loading))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})